<template>
  <div class="row">
    <div class="col-xs-3 vcenter">
      <div class="circle text-center vcenter">
        <svg
          aria-hidden="true"
          data-prefix="fas"
          data-icon="briefcase"
          class="categoryIcon"
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
        >
          <path
            fill="currentColor"
            d="M320 288h192v144c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V288h192v20c0 6.627 5.373 12 12 12h104c6.627 0 12-5.373 12-12v-20zm192-112v80H0v-80c0-26.51 21.49-48 48-48h80V80c0-26.51 21.49-48 48-48h160c26.51 0 48 21.49 48 48v48h80c26.51 0 48 21.49 48 48zM320 96H192v32h128V96z"
          />
        </svg>
      </div>
    </div>
    <div class="col-xs-10 vcenter">
      <p class="title">Опыт работы</p>
    </div>

    <WorkItem v-for="item in items" :key="item.value" :value="item" />
  </div>
</template>

<script>
import WorkItem from "./WorkItem";

export default {
  name: "Education",
  props: {
    items: {}
  },
  components: {
    WorkItem
  }
};
</script>
